<script lang="ts">
  import type { Snippet } from 'svelte';

  // Inline status notice. For floating top-right toasts use ToastHost;
  // Banner is for in-flow messaging anchored to a section (e.g. "verify
  // your email" at the top of /account, or "couldn't save changes" above
  // a form). Variants map to semantic colors from the token palette.
  //
  // role=alert for warn/error so screen readers announce them; status
  // for info/success so they don't interrupt mid-task.

  type Variant = 'info' | 'warn' | 'error' | 'success';

  interface Props {
    variant?: Variant;
    /** Show an X close button. Parent owns visibility via `onDismiss`. */
    dismissible?: boolean;
    onDismiss?: () => void;
    children: Snippet;
  }

  let { variant = 'info', dismissible = false, onDismiss, children }: Props = $props();

  const role = $derived(variant === 'warn' || variant === 'error' ? 'alert' : 'status');
</script>

<div class="ui-banner ui-banner--{variant}" {role}>
  <div class="ui-banner__body">{@render children()}</div>
  {#if dismissible}
    <button
      class="ui-banner__close"
      type="button"
      aria-label="Dismiss"
      onclick={() => onDismiss?.()}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <line x1="6" y1="6" x2="18" y2="18" />
        <line x1="6" y1="18" x2="18" y2="6" />
      </svg>
    </button>
  {/if}
</div>
